/**
 * @since 1.0.0
 * @author ApMod Development Team
 */

import { ClientContextService } from './client-context.service';
import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { filter } from 'rxjs/operators';
import { Observable } from 'rxjs';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  // used if the user is in some route and the token is expired,
  // so after successful login he/she should be redirected to same location

  /**
   * This will be set by route guard
   */
  redirectUrl: string;
   private _oauthObservable: Observable<any>;

  constructor(
    private _oauthService: OAuthService, private _clientContextService: ClientContextService
  ) {

    // Automatically load user profile
    this._oauthObservable = this._oauthService
      .events
      .pipe(filter(e => (e.type === 'token_received' || e.type === 'token_refreshed')));
      // .subscribe((_) => {
      //   // do something
      // });

  }

  signIn(): void {
    this.initializeOauthService();
    this._oauthService.loadDiscoveryDocumentAndLogin({state: encodeURIComponent(window.location.hash)});
  }

  initializeOauthService(signIn: boolean = false): void {
    const userPoolId = this._clientContextService.clientContext.dynamicConfigs['userPoolId'];
    const clientId = this._clientContextService.clientContext.dynamicConfigs['clientId'];
    const domainUrl = this._clientContextService.clientContext.dynamicConfigs['domainUrl'];
    const region = this._clientContextService.clientContext.dynamicConfigs['region'];


    this._oauthService.configure({
      issuer: `https://cognito-idp.${region}.amazonaws.com/${userPoolId}`,
      redirectUri: window.location.origin,
      clientId: clientId,
      logoutUrl: `${domainUrl}/logout?client_id=${clientId}&logout_uri=${window.location.origin}&redirect_uri=${window.location.origin}`,
      responseType: 'code',
      scope: 'email openid phone profile',
      oidc: true,
      showDebugInformation: true,
      strictDiscoveryDocumentValidation : false
    });
    this._oauthService.setupAutomaticSilentRefresh();
    this._oauthService.setStorage(localStorage);
    // this._oauthService.loadDiscoveryDocument();
    if(!signIn) {
      this._oauthService.loadDiscoveryDocument();
    }
  }

  logout(): void {
    this._oauthService.logOut({
      client_id: this._oauthService.clientId, logout_uri: window.location.origin, redirect_uri: window.location.origin
    });
  }

  get idToken(): string {
    return this._oauthService.getIdToken();
  }

  get accessToken(): string {
    return this._oauthService.getAccessToken();
  }

  get hasValidToken(): boolean {
    return this._oauthService.hasValidAccessToken();
  }

  refresh(): void {
    this._oauthService.refreshToken();
  }

  verifyToken(): void {
    const expires_at = localStorage.expires_at;
    const expires = moment(parseInt(expires_at, 10)).format('DD MMM YYYY hh:mm a');
    console.log('Token expires at', expires);
    const isTokenExpired = moment().isAfter(moment(parseInt(localStorage.expires_at, 10)));

    if (!this.hasValidToken || isTokenExpired) {
      this.logout();
    }
  }
}
